/** @jsxRuntime classic */
/** @jsx React.createElement */
import * as React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import { RootWrapper } from '@/components/root-wrapper';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
  <RootWrapper>{element}</RootWrapper>
);
